import React from "react";
import {
  Box,
  Divider,
  styled,
  Switch,
  Typography,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import InsuranceIcon from "@icons/myicons/insurance.svg?react";
import { Settings2FAContext } from "../stateMachine";
import { AuthApps } from "./AuthApps";

const IconBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 40,
  height: 40,
  borderRadius: "8px",
  backgroundColor: theme.palette.background.subtle,
  border: `1px solid ${theme.palette.primary.main}`,
}));

interface Props {
  context: Settings2FAContext;
  onToggle: () => void;
}

export const InfoView = ({ context, onToggle }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const is2FAEnabled = context.is2FAEnabled;
  const key = is2FAEnabled ? "enabled" : "disabled";

  const label = (
    <Typography variant="body3" color="textSecondary">
      {t(`settings.twoFA.${key}.toggle`)}
    </Typography>
  );

  return (
    <>
      <Box display="flex" flexDirection="column" gap={7}>
        <Box display="flex" alignItems="center" gap={2.5}>
          <IconBox>
            <InsuranceIcon color={theme.palette.primary.main} />
          </IconBox>
          <Typography variant="body3" color="textSecondary">
            {t(`settings.twoFA.${key}.description`)}
          </Typography>
        </Box>
        {is2FAEnabled && (
          <Typography variant="body3" color="textSecondary">
            {t(`settings.twoFA.${key}.description1`)}
          </Typography>
        )}
        <Box display="flex" gap={5} alignItems="center">
          {is2FAEnabled && label}
          <Switch
            data-testid="2fa-toggle-switch"
            data-value={is2FAEnabled}
            size="medium"
            checked={is2FAEnabled}
            onChange={onToggle}
          />
          {!is2FAEnabled && label}
        </Box>
      </Box>
      <Divider sx={{ my: 7.5, borderColor: theme.palette.border.secondary }} />
      <Box display="flex" flexDirection="column" gap={7}>
        <Typography variant="h6">
          {t(`settings.twoFA.methods.title`)}
        </Typography>
        <Typography variant="body3" color="textSecondary">
          {t(`settings.twoFA.methods.subtitle`)}
        </Typography>
        <AuthApps />
      </Box>
    </>
  );
};
